import { inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { Tool } from "@aws-sdk/client-bedrock-runtime";
import { AITool } from "../../../03_model/ai-tool.interface";
import { AIToolResponseMessage } from "../../../03_model/ai-chat-message.model";
import { CustomerRepository } from "../../../04_repository/customer.repository";

export class SearchCustomerTool implements AITool {

  tool_name = 'search_customer';
  customerRepo = inject(CustomerRepository);

  description = <Tool>{
    "toolSpec": {
      "name": this.tool_name,
      "description": "Search for customers in the database by name.",
      "inputSchema": {
        "json": {
          "type": "object",
          "properties": {
            "name": {
              "type": "string",
              "description": "The name of the customer to search for in the database."
            }
          },
          "required": [
            "name"
          ]
        }
      }
    }
  };

  async invoke({name}: {name?: string}): Promise<AIToolResponseMessage> {
    if (!name) {
      return {
        type: 'tool-response',
        role: 'user',
        content: `Tool result: No name parameter provided for customer search.`,
        requiresFollowUp: true,
      };
    }
    try {
      const page = await firstValueFrom(this.customerRepo.getCustomerPage({ pageSize: 100, lastKey: null, sortKey: 'name', sortDirection: 'asc', searchParameters: [] }));
      const customers = page.data.filter(c => c.name.includes(name));
      return {
        type: 'tool-response',
        role: 'user',
        content: `Tool result: Found ${customers.length} customers with name including "${name}": ${customers.map(c => `ID: ${c.id}, Name: ${c.name}`).join('; ')}`,
        requiresFollowUp: true,
      };
    } catch (e) {
      return {
        type: 'tool-response',
        role: 'user',
        content: `Tool result: An error occurred while searching for customers with name including "${name}". Error details: ${e}`,
        requiresFollowUp: true,
      };
    }
  }
}
